import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import '../Assets/css/footerListdoc.scss';
import '../Assets/css/footerListresponsivedoc.scss';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import { withRouter, useHistory } from 'react-router-dom';
import BreadcrumbMenu from '../../../Utility/Components/BreadcrumbMenu';

function AboutUs(props) {


    const history = useHistory();

    useEffect(() => {


    }, []);

    const homeMenuClick = () => {
        history.push(`/${localStorage.getItem('i18nextLng')}/home`);
    }



    return (

        <div className="aboutUsPage">
            <div className='footerBoxCover'>
                <div className='container'>
                    <div className="filterBox filterBoxMBottom">
                        <div className="leftSectionFilter">
                            <h2 className="pageTitle">About Us</h2>
                        </div>
                    </div>
                </div>
            </div>


            <div className='container'>
                <BreadcrumbMenu
                    homeMenuDisplay={true}
                    aboutDisplay={true}
                    homeMenuClick={homeMenuClick}
                    activeAbout={true}
                />

                <div className='aboutPageDetails paddingPageDetails'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='aboutbox'>
                                <h4>About TheStaying.com <br></br><strong>Curated Spaces for the Curious Traveller</strong></h4>
                                <p>At TheStaying.com, we believe travel is more than reaching a destination. It is about discovering places, connecting with local cultures and creating experiences that stay with you long after the journey ends. We are a travel platform bringing together distinctive stays, thoughtfully curated travel experiences, personalised itineraries and signature tours to help travellers explore the world in more meaningful ways.</p>
                                <p>Whether you are planning a family holiday, a romantic getaway, a cultural exploration or an independent adventure, TheStaying helps you discover travel possibilities suited to your interests, preferences and pace.</p>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='aboutbox'>
                                <h4><strong>What We Do</strong></h4>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Discover Distinctive Stays</h5>
                                    <p className="card-text">Explore a selection of hotels, homestays and unique accommodation options that offer different ways to experience a destination.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Personalised Travel Planning</h5>
                                    <p className="card-text">Discover customised itineraries and travel arrangements designed around individual preferences, travel objectives and available budgets.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Curated Experiences and Signature Tours</h5>
                                    <p className="card-text">From cultural heritage and local traditions to immersive destination experiences, our tours are designed to bring travellers closer to the character and stories of each place.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Travel Industry Collaboration</h5>
                                    <p className="card-text">We work towards connecting travellers, accommodation providers, travel professionals and tourism partners through collaborative opportunities that support meaningful travel experiences and sustainable business relationships.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Our Approach</h5>
                                    <p className="card-text">We believe that every traveller has a different idea of the perfect journey. That is why we emphasise discovery, personalisation and thoughtful curation rather than a one-size-fits-all approach.</p>
                                    <p className="card-text">By bringing travel options, local experiences and industry partnerships together, we aim to make travel planning more accessible, coordinated and rewarding.</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Our Vision</h5>
                                    <p className="card-text">To become a trusted travel platform recognised for distinctive stays, meaningful experiences and collaborative growth across the travel ecosystem.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Our Mission</h5>
                                    <p className="card-text">To simplify travel discovery, connect people with authentic experiences and create opportunities for travellers and tourism partners to grow together.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Travel That Stays With You</h5>
                                    <p className="card-text">Every destination has a story. Every journey creates a memory. At TheStaying.com, we help you find the places and experiences that make your journey uniquely yours.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Discover differently. Travel meaningfully. Stay inspired.</h5>
                                    <p className="card-text">Explore your next journey with <a href='https://thestaying.com' target='_blank'>www.thestaying.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}





const mapStateToProps = (globalState) => {
    return {
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })
    (withNamespaces()(AboutUs));